import * as Yup from "yup";

const regExpOnlyLetter = /^[ñíóáéú a-zA-Z ]+$/;
const PhoneRegExp = /^[0-9 ]\d{6,9}$/;

export const validationReport = Yup.object().shape({
  name: Yup.string()
    .matches(regExpOnlyLetter, "Por favor escriba únicamente letras.")
    .required("Campo obligatorio.")
    .max(20, "Máximo 20 caracteres."),
  phoneNumber: Yup.string()
    .matches(PhoneRegExp, "Por favor escriba un número de teléfono válido, solo números.")
    .required("Campo obligatorio."),
  description: Yup.string().max(500, "Máximo 500 caracteres.").required("Campo obligatorio."),
});
